import React from 'react';
import { Box, Button, Container, Divider, Grid, Typography, Stack, IconButton } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";

import logo from '../../../assets/images/ate/logoa.svg';
import { domain } from "../../../apiRoutes/apiBase";

export default function Footer() {
    const { t } = useTranslation();
    const history = useHistory();

    const redirect = (route) => {
        history.push(route);
    }

    // Estilo unificado y limpio para los enlaces del footer
    const footerLinkStyle = {
        color: '#94a3b8',
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: '500',
        justifyContent: 'flex-start',
        p: 0,
        minWidth: 'auto',
        transition: 'color 0.3s ease',
        '&:hover': {
            color: '#38bdf8', // Azul brillante al hacer hover
            bgcolor: 'transparent'
        }
    };

    return (
        <Box sx={{ 
            bgcolor: '#0f172a', // Azul noche premium, conectando con ContactUs2
            backgroundImage: 'linear-gradient(to bottom, #0f172a, #020617)', 
            color: 'white',
            pt: { xs: 10, md: 12 },
            pb: 4,
            position: 'relative',
            overflow: 'hidden'
        }}>
            
            {/* Brillo sutil superior para suavizar la transición desde el componente de arriba */}
            <Box sx={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '60%', height: '1px', bgcolor: 'transparent', boxShadow: '0 0 40px 2px rgba(96, 165, 250, 0.15)' }} />

            <Container maxWidth='xl'>
                <Grid container spacing={6} justifyContent={'space-between'}>
                    
                    {/* COLUMNA 1: Logo y Redes Sociales */}
                    <Grid item xs={12} md={4} lg={3}>
                        <Box sx={{ mb: 4 }}>
                            {/* El filter asegura que el logo se vea blanco sobre el fondo oscuro */}
                            <img style={{ width: 120 }} src={logo} alt="QUD" />
                        </Box>
                        <Typography variant="body2" sx={{ color: '#94a3b8', mb: 4, lineHeight: 1.6, pr: { md: 4 } }}>
                            El ecosistema digital que conecta tu negocio con la ciudad. Vende, gestiona y fideliza desde un solo lugar.
                        </Typography>
                        <Stack direction="row" spacing={2}>
                            <IconButton LinkComponent={'a'} target="_blank" href="https://www.instagram.com/qud.life/" sx={{ bgcolor: 'rgba(255,255,255,0.05)', color: '#94a3b8', '&:hover': { bgcolor: '#E4405F', color: 'white' }, transition: '0.3s' }}>
                                <FontAwesomeIcon icon={faInstagram} fontSize="1.1rem" />
                            </IconButton>
                            <IconButton LinkComponent={'a'} target="_blank" href="https://www.facebook.com/qud.life/" sx={{ bgcolor: 'rgba(255,255,255,0.05)', color: '#94a3b8', '&:hover': { bgcolor: '#1877F2', color: 'white' }, transition: '0.3s' }}>
                                <FontAwesomeIcon icon={faFacebookF} fontSize="1.1rem" />
                            </IconButton>
                            <IconButton LinkComponent={'a'} target="_blank" href="https://twitter.com/qud_life" sx={{ bgcolor: 'rgba(255,255,255,0.05)', color: '#94a3b8', '&:hover': { bgcolor: '#1DA1F2', color: 'white' }, transition: '0.3s' }}>
                                <FontAwesomeIcon icon={faTwitter} fontSize="1.1rem" />
                            </IconButton>
                        </Stack>
                    </Grid>

                    {/* COLUMNA 2: Soluciones */}
                    <Grid item xs={12} sm={4} md={2}>
                        <Typography variant="h6" fontWeight={'800'} mb={3} color="white">
                            {t('helpers.solutions')}
                        </Typography>
                        <Stack spacing={2} alignItems="flex-start">
                            <Button variant="text" sx={footerLinkStyle} onClick={() => redirect('merchants')}>
                                {t('helpers.merchants')}
                            </Button>
                            <Button variant="text" sx={footerLinkStyle} onClick={() => redirect('forpeople')}>
                                {t('helpers.people')}
                            </Button>
                        </Stack>
                    </Grid>

                    {/* COLUMNA 3: Legal */}
                    <Grid item xs={12} sm={4} md={2}>
                        <Typography variant="h6" fontWeight={'800'} mb={3} color="white">
                            Legal
                        </Typography>
                        <Stack spacing={2} alignItems="flex-start">
                            <Button variant="text" sx={footerLinkStyle} LinkComponent="a" target="_blank" href={domain+'privacy'}>
                                {t('helpers.privacy')}
                            </Button>
                            <Button variant="text" sx={footerLinkStyle} LinkComponent="a" target="_blank" href={domain+'termsandconditions'}>
                                {t('helpers.terms')}
                            </Button>
                        </Stack>
                    </Grid>

                    {/* COLUMNA 4: App */}
                    <Grid item xs={12} sm={4} md={2}>
                        <Typography variant="h6" fontWeight={'800'} mb={3} color="white">
                            {t('helpers.app')}
                        </Typography>
                        <Stack spacing={2} alignItems="flex-start">
                            <Button variant="text" sx={footerLinkStyle}>
                                Google Play
                            </Button>
                            <Button variant="text" sx={footerLinkStyle}>
                                App Store
                            </Button>
                        </Stack>
                    </Grid>

                </Grid>

                <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mt: 8, mb: 4 }} />
                
                {/* BOTTOM FOOTER: Branding y Copyright */}
                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems="center" gap={2}>
                    <Box textAlign={{ xs: 'center', md: 'left' }}>
                        <Typography variant='caption' sx={{ color: '#64748b', letterSpacing: 1, textTransform: 'uppercase' }}>
                            Powered by
                        </Typography>
                        <Typography variant='h5' sx={{ color: '#f8fafc', mt: -0.5 }}>
                            QUD
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant='body2' sx={{ color: '#64748b', fontWeight: 500 }}>
                            &copy; {new Date().getFullYear()} ATE. Todos los derechos reservados.
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}